<template>
  <div
    ref="root"
    :class="$style.root"
  >
    <base-dropdown
      placement="bottom-end"
      @change="handleState"
    >
      <template #default="{ toggle }">
        <base-button
          type="button"
          size="xs"
          icon="options-2-18"
          data-qa="settings"
          @click="toggle"
        >
          {{ $trlMessage('vacancy.quota.modal.settings') }}
        </base-button>
      </template>
      <template #content="{ hide }">
        <local-items-filter
          v-if="selectedSchemaComputed"
          :fields="{ title: 'title' }"
          :items="schemaFields"
          :default-query="query"
          highlight
        >
          <template #default="{ query, setQuery, items }">
            <dropdown-autocomplete
              multiple
              dropdown-size="large"
              caption-field="title"
              placement="bottom-end"
              :add-layer="false"
              :dropdown-shown="true"
              :items="items"
              :value="selectedSchemasFieldsIds"
              :query="query"
              :max-height="DROPDOWN_AUTOCOMPLETE_MAX_HEIGHT"
              :dropdown-reference="$refs.root"
              data-qa="visibility-settings-list"
              @change="handleFieldsSelect($event)"
              @search="setQuery"
              @hide="hide"
            />
          </template>
        </local-items-filter>
        <select-list
          v-else
          :class="$style.select"
          :items="schemaItems"
          inline
          @change="handleSchemaSelect"
        />
      </template>
    </base-dropdown>
  </div>
</template>

<script>
import DropdownAutocomplete from '@/components/base-autocomplete/dropdown-autocomplete.vue';
import SelectList from '@/components/select-list/select-list.vue';
import BaseButton from '@/shared/legacy/ui/button/button.vue';
import LocalItemsFilter from '@/shared/legacy/lib/local-items-filter/local-items-filter.vue';
import { compare } from '@/shared/legacy/lib/compators/compators';
import BaseDropdown from '@/shared/legacy/ui/base-dropdown/base-dropdown.vue';

const DROPDOWN_AUTOCOMPLETE_MAX_HEIGHT = 490;

export default {
  name: 'ModalSettings',
  components: {
    BaseButton,
    SelectList,
    DropdownAutocomplete,
    LocalItemsFilter,
    BaseDropdown
  },
  props: {
    schemas: {
      type: Array,
      required: true
    },
    schemasFields: {
      type: Object,
      required: true
    },
    selectedSchemasFields: {
      type: Object,
      required: true
    }
  },
  emits: ['change'],
  data() {
    return {
      selectedSchemaId: null,
      DROPDOWN_AUTOCOMPLETE_MAX_HEIGHT
    };
  },
  computed: {
    singleSchema() {
      return this.schemas.length === 1;
    },
    schemaItems() {
      return this.schemas.map(({ id, name }) => ({
        id,
        name
      }));
    },
    selectedSchemaComputed() {
      return this.singleSchema ? this.schemas[0].id : this.selectedSchemaId;
    },
    schemaFields() {
      return [...this.schemasFields[this.selectedSchemaComputed]].sort((a, b) =>
        compare(a, b, 'title')
      );
    },
    selectedSchemasFieldsIds() {
      return this.selectedSchemasFields[this.selectedSchemaComputed].map(({ id }) => id);
    }
  },
  methods: {
    handleState(flag) {
      if (!flag) {
        this.selectedSchemaId = null;
      }
    },
    handleSchemaSelect({ id }) {
      this.selectedSchemaId = id;
    },
    handleFieldsSelect(ids) {
      const fields = ids.map((id) => this.schemaFields.find((item) => item.id === id));

      this.$emit('change', {
        id: this.selectedSchemaComputed,
        fields
      });
    }
  }
};
</script>

<style module>
.root {
  flex: 0 0 auto;
}
.autocomplete {
  margin-top: 10px;
  width: $largeWidth;
}
.select {
  width: $largeWidth;
}
</style>

<i18n lang="json">{}</i18n>
